// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"2be03a30fd90b4dab833","655":"02d8cdbe5a404a2fc8af"}[chunkId] + ".js";
};